import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../redux/store";
import {fetchDataAllPrice, fetchDataCityPrice, fetchDataPrice} from "../../../../redux/priceReducer";
import {
    collapseChart,
    selectChart,
    selectCitiesPriceColumnCityChart,
    selectDataPriceColumnCityChart,
    selectDataPriceColumnForAllChart,
    selectDataPriceLineChart,
    selectOrderSpm,
    selectSpmPriceColumnCityChart,
    selectSpmPriceColumnForAllChart, selectSpmPriceForLineChart,
    selectTimePriceColumnCityChart,
    selectTimePriceColumnForAllChart,
    selectTimePriceLineChart
} from "../../../../common/selectors";
import {PriceLineChart} from "./priceLineChart";
import {PriceColumnChart} from "./priceColumnChart";
import {EmptyComponent} from "../../../../common/empty";
import dayjs from "dayjs";

// Компонент графиков цен, отображает три типа графиков: по РФ, по Москве, по городам
export const PriceCharts = () => {
    // Получаем dispatch для работы с redux
    const dispatch = useAppDispatch()

    // Получаем временные диапазоны для разных графиков
    const time = useAppSelector(selectTimePriceLineChart)
    const timeAll = useAppSelector(selectTimePriceColumnForAllChart)
    const timeCity = useAppSelector(selectTimePriceColumnCityChart)

    // Получаем выбранные маркетплейсы для графика линий
    const spmLineChart = useAppSelector(selectSpmPriceForLineChart)
    // Получаем выбранные маркетплейсы для графика столбцов
    const spmAll = useAppSelector(selectSpmPriceColumnForAllChart)
    // Получаем порядок маркетплейсов для оси X
    const orderSpm = useAppSelector(selectOrderSpm)
    // Получаем выбранные маркетплейсы для графика по городам
    const spmCity = useAppSelector(selectSpmPriceColumnCityChart)
    // Получаем выбранные города для графика по городам
    const city = useAppSelector(selectCitiesPriceColumnCityChart)

    // Получаем данные для каждого графика
    const data = useAppSelector(selectDataPriceLineChart)
    const dataAll = useAppSelector(selectDataPriceColumnForAllChart)
    const dataCity = useAppSelector(selectDataPriceColumnCityChart)

    // Получаем состояние раскрытия графиков
    const collapse = useAppSelector(collapseChart)
    // Получаем выбранный тип графика
    const chart = useAppSelector(selectChart)

    // Формируем параметры для запросов
    let paramLineChart = ''
    spmLineChart.forEach((el) => paramLineChart += el + ',')
    let paramSupermarkets = ''
    spmAll.forEach((el) => paramSupermarkets += el + ',')
    let paramCities = ''
    city.forEach((el) => paramCities += el + ',')

    // Эффект загрузки данных для всех графиков при изменении параметров
    useEffect(() => {
        dispatch(fetchDataPrice({from_date: time[0], to_date:dayjs(time[1]).day(7).format('YYYY-MM-DD'), seller_name: paramLineChart}))
        dispatch(fetchDataAllPrice({from_date: timeAll[0], to_date: timeAll[1], seller_name: paramSupermarkets}))
        dispatch(fetchDataCityPrice({
            from_date: timeCity[0],
            to_date: timeCity[1],
            seller_name: spmCity,
            city_name: paramCities
        }))
    }, [time, timeAll, timeCity, dispatch, paramSupermarkets, paramCities, spmCity, paramLineChart])

    // Функция для формирования заголовка графика
    const getTitle = (date: string[]) => {
        if (dayjs(date[0]).valueOf() < 1735506000000) {
            return [
                `${chart} по РФ`,
                `${chart} по городам`
            ]
        }
        else {
            return [
                `${chart} по Москве`,
                `${chart} по городам`
            ]
        }
    }

    // ...рендер...
    return (
        <div style={{height: '100%'}}>
            {/* График по РФ или Москве (линейный) */}
            {collapse.includes('1')&&(data.length ? <PriceLineChart data={data}
                                    time={time}
                                    title={getTitle(time)[0]}
            /> : <EmptyComponent/>)}
            {/* График по маркетплейсам (столбцы) */}
            {collapse.includes('2')&&(dataAll.length ? <PriceColumnChart data={dataAll}
                               time={timeAll}
                               title={getTitle(timeAll)[0]}
                               categoriesXaxis={orderSpm}
                               chart={chart}
                               typeChart={'spm'}
            /> : <EmptyComponent/>)}
            {/* График по городам (столбцы) */}
            {collapse.includes('3')&&(dataCity.length ? <PriceColumnChart data={dataCity}
                               time={timeCity}
                               title={getTitle(timeCity)[1]}
                               categoriesXaxis={city}
                               chart={chart}
                               typeChart={'city'}
                               spmCity={spmCity}
            /> : <EmptyComponent/>)}
        </div>
    );
};
// ...конец файла...
